import React from 'react';
import {CircularProgress, Dialog, Link, DialogContent, Grid, Typography, withStyles, Button, Switch, Avatar} from '@material-ui/core';
import CollVis from './CollVis';
import Legend from '../components/Legend';
import DateFilter from './DateFilter';
import CheckboxGroup from './utils/CheckboxGroup';
import {legendActions} from '../actions/legend.actionCreators';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Box from '@material-ui/core/Box';
import {ArrowBack, Tune} from '@material-ui/icons';
import blueGrey from '@material-ui/core/colors/blueGrey';
import {getLabels} from '../constants/labels';
import TakeScreenshot from './TakeScreenshot';
import CardsDisplay from './CardsDisplay';
import {
    CONTINENT_ARC_COLOR,
} from '../constants/colors';

const tableCellStyle = {
    padding: '5px 10px 5px 10px',
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    textOverflow: 'ellipsis'
};
const normalCellStyle = {
    ...tableCellStyle
};
const nameCellStyle = {
    whiteSpace: 'normal'
};
const partnersCellStyle = {
    whiteSpace: 'normal'
};
const styles = theme => ({
    canvas: {
        flexGrow: 1,
        marginBottom: 10
    },
    leftSide: {
        backgroundColor: '#f3f3f3',
        borderRadius: '11px',
        padding: '5px 30px'
    },
    title: {
        padding: "4px 4px 4px 4px",
        color: "#384257",
        marginTop:17,
        marginBottom:10,
        fontSize:20,
    },
    titleDate: {
        padding: "4px 4px 0px 30px",
        color: "#384257",
        marginTop:15,
        fontSize:16,
        fontWeight: 'bold'
    },
    filterTitle: {
        paddingBottom: 10,
        paddingRight: 10,
        fontWeight: 'bold'
    },
    filter: {
        paddingTop: '5px',
        width: '100%'
    },
    rightSide: {
        position: 'relative',
        borderRadius: '11px',
        backgroundColor: 'white'
    },
    visItem: {
        [theme.breakpoints.down('sm')]: {
            padding: '0 0%'
        },
        [theme.breakpoints.up('md')]: {
            padding: '0 0%'
        },
        [theme.breakpoints.up('lg')]: {
            padding: '0 5%'
        }
    },
    dialogContent: {
        padding: '0px 20px 15px 20px'
    },
    entityFilter: {
        position: 'absolute',
        top: 10,
        left: 10
    },
    hidden: {
        visibility: 'hidden'
    },
    noWheelResults: {
        textAlign: 'center',
        padding: 30
    },
    resetAll: {
        padding: 0,
        fontSize: 11
    },
    switch: {
        justifyContent: 'flex-end'
    },
    switchDetail: {
        height: 48,
        width: 68
    },
    switchBase: {
        '&:hover': {
            backgroundColor: 'transparent'
        },
        '&$checked': {
            '&:hover': {
                backgroundColor: 'transparent !important'
            },
            '& + $track': {
              backgroundColor: CONTINENT_ARC_COLOR,
              opacity: 1
            }
        },
        '& + $track': {
            backgroundColor: CONTINENT_ARC_COLOR,
            opacity: 1
        }
    },
    thumb: {
       marginTop: 5,
       marginLeft: 5,
       color: 'white',
       width: 20,
       height: 20,
    },
    track: {
        borderRadius: 48 / 2,
    },
    checked: {},
    focusVisible: {},
    filterIcon: {
        backgroundColor: "#d4e2e9",
        border: `1.7px solid #384257`,
        color:'black',
        width: 38,
        height: 38,
        webkitTransform: "rotate(270deg) scaleY(-1)",
        transform: "rotate(270deg) scaleY(-1)",
        marginTop:15,
        marginBottom: 5,
        marginRight: 3
      },
    icon: {
        height:31,
        width:31,
        stroke: "#d4e2e9",
        strokeWidth: 0.2,
        color:"#384257"
    }
});

const ColorButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText('#A1ADB8'),
        backgroundColor: '#A1ADB8',
        '&:hover': {
            backgroundColor: blueGrey[50]
        }
    }
}))(Button);

export class VisualizationCanvas extends React.Component {

    state = {
        data_collab_types: [],
        data_checked_collabTypes: {},
        checkedAll: true,
        filteredActions: [],
        filteredEntities: [],
        legendDisplayables: {},
        switchState: true,
        workAreaAmounts: [0,0],
        statusAmounts:[0,0,0,0,0,0],
        programs_collapse: false  // programs filter label
    };

    handleChangeSwitch(){
        this.setState((prevState) => ({ switchState: !prevState.switchState }));
    }
    

    loadData() {
        const {actions} = this.props;
        const data_collab_types = this.getCollabTypes();
        const data_checked_collabTypes = this.getCheckedCollabTypes(data_collab_types);
        const legendDisplayables = this.getDisplayableLegends(data_collab_types);
        this.setState({data_collab_types, data_checked_collabTypes, legendDisplayables}, () => {
            if (actions && Object.keys(data_checked_collabTypes).length !== 0
                && this.legendCheckshaveChanged(data_checked_collabTypes)) {
                actions.saveChecks(data_checked_collabTypes);
            }
            this.filterActionsAndEntities();
        });
    }

    legendCheckshaveChanged(data_checked_collabTypes = {}) {
        const {legend_checks} = this.props;
        if (!legend_checks || !legend_checks) return true;
        for (const [key, value] of Object.entries(data_checked_collabTypes)) {
            if (legend_checks[key] === undefined) return true;
            if (legend_checks[key] !== value) return true;
        }
        return false;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps !== this.props) this.loadData();
    }

    getCollabTypes() { // Sets the programs' number of coincidences
        const {data} = this.props;
        const data_collab_types = (data.collab_types || []).map(prog => {
            let quantity = 0;
            (data.actions || []).forEach(a => {
                if (a.programId === prog.id.toString() || prog.id.toString().endsWith(`.${a.programId}`)) {
                    quantity = quantity + 1;
                }
            });
            return {...prog, quantity};
        });
        return data_collab_types;
    }

    getActionAmounts() { // Sets the actions' number of coincidences
        const {data} = this.props;
        const workAreaAmounts = data.work_area_amounts
        const statusAmounts = data.status_amounts

        this.setState({
            workAreaAmounts, statusAmounts
        });
    }

    getCheckedCollabTypes(collab_types) {
        const {legend_checks} = this.props;
        let checked_collabTypes = {};
        let current2ndLevelId = '';
        let current2ndLevelValue = true;
        (collab_types || []).forEach(t => {
            let value = true;
            if(t.id.startsWith(current2ndLevelId)) {
                value = current2ndLevelValue;
            }
            const storedValue = legend_checks?.[t.id];
            checked_collabTypes[t.id] = storedValue !== undefined ? storedValue : value;
            if (t.id.split('.').length === 2) {
                current2ndLevelId = t.id;
                current2ndLevelValue = checked_collabTypes[t.id];
            }
        });
        return checked_collabTypes;
    }

    getDisplayableLegends(collab_types) {
        const displayable = {};
        const { legendDisplayables } = this.state;
    
        // If there's already a legendDisplayables list, then we want to keep that information
        // However, if there is new content, it has to be added to the list
        if (Object.keys(legendDisplayables).length !== 0) {
            collab_types.forEach(t => {
                displayable[t.id] = legendDisplayables[t.id] ?? (t.id.split('.').length === 1); // if there are no new items, it stays the same
            });
        } else {
            collab_types.forEach(t => {
                displayable[t.id] = t.id.split('.').length === 1; // lvl 1 programs will display their children items by default
            });
        }
    
        return displayable;
    }

    // Discards links between entities from same country
    getFilteredLinks() {
        const {data} = this.props;
        return (data.links || []).filter(l => {
            const hierarchical_ids1 = l.id1.split('.');
            const hierarchical_ids2 = l.id2.split('.');
            return (!(
                hierarchical_ids1.length >= 1 && hierarchical_ids2.length >= 1 &&
                hierarchical_ids1[0] === hierarchical_ids2[0]
            ));
        });
    }

    checkParentPrograms(linkId, parentState) {
        // Check parent and siblings
        if (linkId.includes('.')) {
            const parentIds = linkId.split('.').slice(0, -1);
            const parentId = parentIds.join('.'); // the actual parent Id's
            const siblingIds = Object.keys(parentState)
                .filter(t => t.startsWith(parentId) && t.split('.').length === linkId.split('.').length);
    
            let allSiblingsChecked = true;
            siblingIds.forEach(siblingId => {
                if (!parentState[siblingId]) {
                    allSiblingsChecked = false;
                }
            });
    
            // Update parent state
            const newParentState = allSiblingsChecked === true;
            parentState[parentId] = newParentState;
    
            // Recursively call with updated state
            this.checkParentPrograms(parentId, parentState);
        } else {
            const siblingIds = Object.keys(parentState)
                .filter(t => !t.includes('.'));
    
            let allSiblingsChecked = true;
            siblingIds.forEach(siblingId => {
                if (!parentState[siblingId]) {
                    allSiblingsChecked = false;
                }
            });
    
            // Update checkedAll state
            this.setState({ checkedAll: allSiblingsChecked });
        }
    }

    filterCollabType(linkId, value) {
        const { actions } = this.props;
    
        let newState;
        if (linkId === '__all__') { // Select/Clear all
            const data_checked_collabTypes = {};
            for (const item in this.state.data_checked_collabTypes) {
                data_checked_collabTypes[item] = value;
            }
            newState = { data_checked_collabTypes, checkedAll: value };
        } else {
            let childrenIds = {};
            Object.keys(this.state.data_checked_collabTypes).forEach(t => {
                if (t.startsWith(linkId)) childrenIds[t] = value;
            });
            newState = {
                data_checked_collabTypes: {
                    ...this.state.data_checked_collabTypes,
                    [linkId]: value,
                    ...childrenIds
                }
            };
        }

        this.setState(newState, () => {
            if (actions) {
                actions.saveChecks(this.state.data_checked_collabTypes);
            }
            this.filterActionsAndEntities();
    
            this.checkParentPrograms(linkId, newState.data_checked_collabTypes);
        });
    }

    getTableColumns() {
        const labels = getLabels(this.props.language);
        // const formatDate = data => moment(data).format('YYYY-MM-DD');
        return [
            {title: labels.name, field: 'name', cellStyle: nameCellStyle},
            // {title: 'Submitted Date', field: 'submitDate', render: formatDate},
            // {title: 'Awarded Date', field: 'awardDate', render: formatDate},
            // {title: 'Start Date', field: 'startDate', render: formatDate},
            // {title: 'End Date', field: 'endDate', render: formatDate},
            {title: labels.program, field: 'program'},
            {title: labels.partners, field: 'partners', cellStyle: partnersCellStyle}
        ].map(col => ({...col, cellStyle: {...normalCellStyle, ...col.cellStyle}}));
    }

    getFilteredActionsByProgram() {
        const {data} = this.props;
        const {data_checked_collabTypes} = this.state;
        return (data.actions || []).filter(a => {
            const hierarchicalId = Object.keys(data_checked_collabTypes).find(t =>
                t === a.programId || t.endsWith(`.${a.programId}`)
            );
            return data_checked_collabTypes[hierarchicalId];
        });
    }

    filterActionsByClickedEntity(actions, clickedEntity) {
        if (clickedEntity === '') {
            return actions;
        }
        const {data: {entities}} = this.props;
        return actions.filter(
            a => {
                const clickedPartner = (a.partnersArray || []).find(p => {
                    const entity = entities.find(e => e.id.endsWith(p));
                    if (!entity) return false;
                    return clickedEntity === entity.id || entity.id.startsWith(clickedEntity);
                });
                return clickedPartner !== undefined;
            }
        );
    }

    getFilteredEntities(filtered_actions, collabTypes) {
        const {data: {entities, clickedEntity}, handleLabelClick} = this.props;
        // If all programs are shown return the full list
        if (Object.values(collabTypes).every(checked => checked)) {
            return entities;
        }
        const idsSet = new Set();
        // get list of partners in filtered actions
        filtered_actions.forEach(a => (a.partnersArray || []).forEach(p => idsSet.add(p)));

        // add ids of every element in hierarchy
        Array.from(idsSet).forEach(eId => {
            const entity = entities.find(e => e.id.endsWith(eId));
            const hierarchy = entity?.id.split('.') || [];
            for (let x = 0; x < hierarchy.length; x++) {
                idsSet.add(hierarchy.slice(0, x + 1).join('.'));
            }
        });
        // if filtered entities do not include de selected entity,
        // clear the filter
        if (clickedEntity !== '' && !idsSet.has(clickedEntity)) {
            handleLabelClick({}, {id: clickedEntity});
        }
        // filter entities
        return entities.filter(e => idsSet.has(e.id));
    }

    handleLegendDisplay(itemId) {
        this.setState({
            legendDisplayables: {
                ...this.state.legendDisplayables,
                [itemId]: !this.state.legendDisplayables[itemId]
            }
        });
    }

    handleProgramsCollapse = () => {
        this.setState((prevState) => ({ programs_collapse: !prevState.programs_collapse }));
    };

    filterActionsAndEntities() {
        const {data: {clickedEntity}} = this.props;
        const {data_checked_collabTypes} = this.state;
        const filteredActionsByProgram = this.getFilteredActionsByProgram();
        const filteredActions = this.filterActionsByClickedEntity(filteredActionsByProgram, clickedEntity);
        const filteredEntities = this.getFilteredEntities(filteredActionsByProgram, data_checked_collabTypes);
        this.setState({
            filteredActions, filteredEntities
        });
        this.getActionAmounts()
    }

    onReset() {
        const resetFunction = this.props.onReset;
        resetFunction()
        this.setState({ checkedAll: true });
    }


    render() {
        const {data, onStatusChange, onCollabAreasChange, handleFilterChange, handleLabelClick, loading, language, signed_user} = this.props;
        const classes = this.props.classes || {};
        const {data_collab_types, data_checked_collabTypes, checkedAll, filteredActions, 
            filteredEntities, workAreaAmounts, statusAmounts} = this.state;
        const data_links = this.getFilteredLinks();
        const title = (text) => <Typography className={classes.title}><b>{text}</b></Typography>;
        const titleDate = (text) => <Typography className={classes.titleDate}><b>{text}</b></Typography>;
        const clickedEntityObj = filteredEntities.find(e => e.id === data.clickedEntity) || {name: ''};
        const labels = getLabels(language);
        return (<>
            <Grid container className={classes.canvas} spacing={1}>
                <Grid item container xs={3}>
                    <Grid item container className={classes.leftSide} direction='column'>
                        <Grid item container direction="row" justifyContent='space-between'>
                            <Grid item container display="flex" direction="row" xs={6}>
                                <Avatar className={classes.filterIcon}>
                                    <Tune className={classes.icon}/>
                                </Avatar>
                                {title(this.props.title)}
                            </Grid>
                            <Grid item xs={4}>
                                <Link href="#" id={`reset_all`}
                                    onClick={() => {
                                        this.onReset();
                                    }}
                                >
                                    <Typography className={classes.resetAll} style={{marginTop:7}}align="right">
                                        <b>{labels.resetAll}</b>
                                    </Typography>
                                </Link>
                            </Grid>
                        </Grid>
                        <br></br>
                        <Grid item container display="flex" direction="row">
                                {titleDate(labels.date)}
                        </Grid>
                        <Grid item className={classes.filter}>
                            <DateFilter
                                language={language}
                                minDate={data.fromDate}
                                maxDate={data.toDate}
                                handleChange={handleFilterChange}
                            />
                        </Grid>
                        {/** collab type filter: all, scientific, innovation */}
                        <Grid item className={classes.filter}>
                            <CheckboxGroup
                                onChange={onCollabAreasChange}
                                data={data.collab_areas}
                                workAreaCoincidences={workAreaAmounts}
                            />
                        </Grid>
                        <Grid item className={classes.filter}>
                            <CheckboxGroup
                                onChange={onStatusChange}
                                data={data.states}
                                statusCoincidences={statusAmounts}
                                signed_user={signed_user}
                            />
                        </Grid>
                        <Grid item className={classes.filter}>
                            <Legend items={data_collab_types}
                                    language={language}
                                    checked={data_checked_collabTypes}
                                    checkedAll={checkedAll}
                                    handleChange={(l, v) => this.filterCollabType(l, v)}
                                    displayables={this.state.legendDisplayables}
                                    handleDisplay={(id) => this.handleLegendDisplay(id)}
                                    handleCollapse={() => this.handleProgramsCollapse()}
                                    collapsed={this.state.programs_collapse}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container xs={9}>
                    <Grid item container className={classes.rightSide}>
                        <Grid item xs={12} className={classes.visItem}>
                            <Dialog open={loading}>
                                <DialogContent className={classes.dialogContent}><CircularProgress/></DialogContent>
                            </Dialog>
                            <Grid component="label" container alignItems="center" spacing={1} className={classes.switch}>
                                <Grid item>{labels.switch_cards_left}</Grid>
                                    <Switch
                                        defaultChecked={true}
                                        disableRipple
                                        value={this.state.switchState}
                                        onChange={() => this.handleChangeSwitch()}
                                        focusVisibleClassName={classes.focusVisible}
                                        classes={{
                                            root: classes.switchDetail,
                                            switchBase: classes.switchBase,
                                            thumb: classes.thumb,
                                            track: classes.track,
                                            checked: classes.checked
                                        }}
                                    />
                                <Grid item>{labels.switch_cards_rigth}</Grid>
                            </Grid>
                            {this.state.switchState ? 
                                (!loading && (!data.entities || data.entities.length === 0) ?
                                    <Typography className={classes.noWheelResults}>{labels.noWheelResults}</Typography> :
                                    <>
                                        <CollVis
                                                entities={filteredEntities}
                                                links={data_links}
                                                category_colors={data.categories}
                                                collabTypes={data_collab_types}
                                                checked={data_checked_collabTypes}
                                                handleLabelClick={handleLabelClick}
                                                clickedEntity={data.clickedEntity}
                                        />
                                        <TakeScreenshot language={this.props.language}/>
                                    </>)
                                : 
                                (<CardsDisplay
                                    signed_user={signed_user}
                                    programs={data.collab_types}
                                    language={language}
                                    actions={filteredActions}
                                />)
                            }
                        </Grid>
                        {data.clickedEntity !== '' ?
                        (<Box className={classes.entityFilter}>
                            <Typography component="div" style={{color: '#A4AFBA'}}>
                                {labels.showingCollaborations(clickedEntityObj.name)}
                            </Typography>
                            <ColorButton
                                variant="contained"
                                style={{marginTop: '10px'}}
                                onClick={(e) => handleLabelClick(e, clickedEntityObj)}
                                startIcon={<ArrowBack/>}
                            >
                                {labels.showAll}
                            </ColorButton>
                        </Box>
                        ):( 
                        <Box className={classes.entityFilter}>
                            {labels.showingCollaborationsResults(filteredActions.length)}
                        </Box>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </>);
    }
}

const mapStateToProps = state => {
    return {
        legend_checks: state.legendReducer.legend_checks
    };
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(legendActions, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VisualizationCanvas));
